import { render } from "./CercaView.vue?vue&type=template&id=4c6d372a&scoped=true"
import script from "./CercaView.vue?vue&type=script&lang=js"
export * from "./CercaView.vue?vue&type=script&lang=js"

import "./CercaView.vue?vue&type=style&index=0&id=4c6d372a&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6d372a"]])

export default __exports__